/**
 * Browser-Download-Glue (Issue #324) — duenne, separat testbare Schicht ueber
 * dem reinen Export-Modul (`./ip-range-export`). Erzeugt einen Blob und einen
 * temporaeren Anchor-Klick; enthaelt keine Format- oder Datenlogik.
 */
export function triggerDownload(
  filename: string,
  mime: string,
  content: string
): void {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
